<template>
    <div class="internal">
        <div class="container">
            <h1 class="page-header">
                <span>Contact
                    <span class="orange-link">Us</span></span>
                <hr />
            </h1>
            <div class="row contact-us d-flex mb-5">
                <div class="col-lg-7 contact-form">
                    <div v-if="errors.length" class="errors">
                        <p>Please correct the following error(s):</p>
                        <ul>
                            <li v-for="error in errors" :key="error">
                                {{ error }}
                            </li>
                        </ul>
                    </div>
                    <div v-if="success" class="success">
                        <b>Your message has been sent successfully</b>
                    </div>
                    <netlify-form name="contact-form" netlify-honeypot="bot-field">
                        <div class="row">
                            <div class="form-group col-md-6">
                                <label for="first-name" class="required">First name</label>
                                <input v-model="firstName" name="firstName" id="first-name" class="form-control"
                                    type="text" placeholder="Your first name" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="last-name" class="required">Last name</label>
                                <input v-model="lastName" name="lastName" id="last-name" class="form-control"
                                    type="text" placeholder="Your last name" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="email-name" class="required">Email</label>
                                <input v-model="email" name="email" id="email-name" class="form-control" type="email"
                                    placeholder="Your email" />
                            </div>
                            <div class="form-group col-md-6">
                                <label for="phone" class="required">Phone</label>
                                <input v-model="phone" name="phone" id="phone" class="form-control" type="text"
                                    placeholder="Your phone" />
                            </div>
                            <div class="form-group col-md-12">
                                <label for="message" class="required">Your message</label>
                                <textarea v-model="message" name="message" id="message" class="form-control"
                                    placeholder="Your message" rows="5"></textarea>
                            </div>
                            <div class="col">
                                <label class="required">GDPR Agreement</label>

                                <div id="checkbox-container" class="checkbox-container">
                                    <input v-model="gdpr" type="checkbox" name="checkbox" id="email-chkbox" required />
                                    <div class="icon-check-container">
                                        <svg class="icon icon-check-square">
                                            <use xlink:href="#icon-check-square"></use>
                                        </svg>
                                    </div>
                                    <label id="chckbox-label" for="email-chkbox">
                                        I consent to having this website store
                                        my submitted information so they can
                                        respond to my enquiry.
                                    </label>
                                </div>
                                <div><a target="_blank" href="https://www.quilter.com/important-information/privacy-notices/appointed-representative-privacy-notice/" class="orange-link">Read our
                                        privacy notice</a></div>
                                <div class="form-group form-button col-md-12">
                                    <button @click="onSubmit" type="submit" class="form-button btn mt-4">
                                        Submit
                                    </button>
                                </div>
                            </div>
                        </div>
                    </netlify-form>
                </div>
                <div class="col-lg-4 mb-auto">
                    <div class="order-10">
                        <div class="address mt-4">
                            <p>
                                <strong>28 Silverwood Close</strong><br />
                                Lowestoft<br />
                                Suffolk<br />
                                NR33 7LX
                            </p>
                        </div>
                        <div>
                            <p>
                                <a class="orange-link" href="tel:01502802347">01502 802347</a>
                            </p>
                            <p>
                                <a class="orange-link" href="mailto:andrew@fridayco.co.uk">andrew@fridayco.co.uk</a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NetlifyForm from "@/components/forms/NetlifyForm";

export default {
    name: "contact-us",
    components: {
        NetlifyForm,
    },
    data() {
        return {
            firstName: null,
            lastName: null,
            phone: null,
            email: null,
            message: null,
            gdpr: false,
            errors: [],
            success: false,
        };
    },
    methods: {
        onSubmit(e) {
            this.errors = [];
            this.success = false;

            if (!this.firstName) {
                this.errors.push("First Name required");
            }
            if (!this.lastName) {
                this.errors.push("Last Name required");
            }
            if (!this.email) {
                this.errors.push("Email required");
            } else if (!this.validEmail(this.email)) {
                this.errors.push("Valid email required");
            }
            if (!this.phone || !this.validPhoneNumber(this.phone)) {
                this.errors.push("Valid phone number required");
            }
            if (!this.message) {
                this.errors.push("Message required");
            }
            if (!this.gdpr) {
                this.errors.push(
                    "We are unable to submit your enquiry, without consent to hold your data"
                );
            }
            if (this.errors.length) {
                e.preventDefault();
            }
        },
        validEmail: function (email) {
            let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        },
        validPhoneNumber: function (phoneNumber) {
            phoneNumber = phoneNumber.replace(/[()]+/g, "");
            let number = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?#(\d{4}|\d{3}))?$/;
            return number.test(phoneNumber);
        },
    },
};
</script>

<style scoped>
.contact-image {
    background-color: #fff;
    border: 5px solid #fff;
}

.brdr {
    border: 15px solid #f7941d;
}

.errors,
.success {
    padding: 15px;
    border-radius: 5px;
    margin-bottom: 30px;
}

.success {
    color: #1c723d;
    background-color: #d7f8e5;
    border-color: #c6f5d6;
}

.errors {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/ContactUs.vue